<template>
  <b-card
    tabindex="0"
    role="navigation"
    img-top
    class="mb-2 mr-2 pointer col-12 col-sm-6 col-md-4 col-lg-3 col-xl-2 p-0 rounded"
    @click="!isDisabled ? advance(id) : showExpired(true)"
    @keyup.enter="!isDisabled ? advance(id) : showExpired(true)"
    v-bind:class="{ disabled: isDisabled }"
    :aria-label="name"
  >
  <SkeletonLoader v-if="imageLoading" image-top></SkeletonLoader>
    <b-card-img  v-if="!imageLoading" :src="image" :alt="name + ' Banner'"></b-card-img>
    <div class="p-4">
      <b-card-title>{{ name }}</b-card-title>
      <b-card-text>
        <p v-if="start_date !== '' && end_date !== ''">
          {{ start_date }} - {{ end_date }}
        </p>
        <p
          class="card-description"
          v-if="description !== '' || description !== null"
        >
          {{ description }}
        </p>
      </b-card-text>
    </div>
  </b-card>
</template>

<script>
import axios from "axios";
import SkeletonLoader from "@/components/SkeletonLoader.vue";
const defaultImage = require("../assets/default-image.jpg");

export default {
  name: "Card",
  components:{
    SkeletonLoader,
  },
  props: {
    data: Object,
    type: String,
    id: Number,
    name: String,
    start_date: {
      type: String,
      default: "",
    },
    end_date: {
      type: String,
      default: "",
    },
    description: {
      type: String,
      default: "",
    },
    step: Number,
    selfOptin: Boolean,
    custSignup: Boolean,
    isDisabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      currStep: this.step,
      cardData: this.data,
      showModal: false,
      image: defaultImage,
      imageLoading: false,
    };
  },
  created() {
    this.getStarted();
  },
  methods: {
    getStarted(){
      let imgRequest = null;

      if (this.type == "group") {
        imgRequest = this.getGroupImage();
      } else if (this.type == "campaign") {
        imgRequest = this.getCampaignImage();
      } else {
        imgRequest = this.getOfferImage();
      }
      this.imageLoading = true;
      imgRequest
        .then((res) => {
          if (res && res.data) {
            this.image = res.data === "" ? defaultImage : res.data;
          }
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          this.imageLoading = false;
        });
    },
    advance(id) {
      if (this.currStep < 3) {
        this.currStep += 1;
        this.$emit("advance", [this.currStep, Number(id)]);
      } else if (this.currStep == 3) {
        //Pass custSignup selfOptin into Form
        let data = Object.assign({}, this.data, {
          custSignup: this.custSignup,
          selfOptin: this.selfOptin,
        });
        this.$router.replace({ name: "form", params: { data } });
      }
      this.setImage();
    },
    setImage() {
      this.$emit('setImage', this.image);
    },
    showExpired(exp) {
      this.$emit("showExpired", exp);
    },
    getGroupImage() {
      return axios.get(`/admin/group-image?groupID=${this.id}`);
    },
    getCampaignImage() {
      return axios.get(`/admin/campaign-image?campaignID=${this.id}`);
    },
    getOfferImage() {
      return axios.get(`/admin/offer-image?offerID=${this.id}`);
    },
  },
};
</script>

<style scoped>
.card-item {
  height: 100%;
  background: #fff;
  box-shadow: 0px 2px 4px #ccc;
  padding: 1.5rem;
  margin: 0 0.5rem;
  cursor: pointer;
}

img {
  border-radius: 0.25rem 0.25rem 0 0 !important;
}

.card-body {
  padding: 0;
}

.card-title,
.card-description {
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 5;
  -webkit-box-orient: vertical;
}

.disabled {
  background-color: rgba(105, 105, 105, 0.3);
}

button {
  max-width: 30%;
}
</style>
